// // utils/hooks/useSegment.ts
// import { useEffect, useState } from "react";

// export function useSegment<T extends string>(key: string, initial: T) {
//   const [segment, setSegment] = useState<T>(() => {
//     if (typeof window === "undefined") return initial;
//     const saved = localStorage.getItem(key);
//     return (saved as T) || initial;
//   });

//   useEffect(() => {
//     localStorage.setItem(key, segment);

//     return () => {
//       return localStorage.removeItem(key);
//     };
//   }, [key, segment]);

//   return { segment, setSegment };
// }

// utils/hooks/useSegment.ts
import { useEffect, useState } from "react";

export function useSegment<T extends string>(
  key: string,
  initial: T,
  shouldRemove = true
) {
  const [segment, setSegment] = useState<T>(() => {
    if (typeof window === "undefined") return initial;
    const saved = localStorage.getItem(key);
    return (saved as T) || initial;
  });

  useEffect(() => {
    localStorage.setItem(key, segment);

    return () => {
      if (shouldRemove) {
        localStorage.removeItem(key);
      }
    };
  }, [key, segment, shouldRemove]);

  return { segment, setSegment };
}
